import React from 'react'

import { Helmet } from 'react-helmet'

// import Hero2 from '../components/hero2'
import Hero3 from '../components/hero3'
import styles from './index.module.css'
import Family from './family2'
import Schedule from './schedule'
import Savings from './savings'
import Countdown from './countdown'
import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';


const Welcome = (props) => {
  return (
    <div className={styles['container']}>
      <Helmet>
        <title>YouAndMe</title>
        <meta property="og:title" content="YouAndMe" />
      </Helmet> 
      <AnimationOnScroll animateIn="animate__zoomIn" delay="300" duration ="2.5" >
        <Hero3 rootClassName="root-class-name"></Hero3>
      </AnimationOnScroll> 
      <AnimationOnScroll animateIn="animate__zoomIn" delay="1" duration ="2.5">
      <Family/>
      </AnimationOnScroll>
      
      {/* <Schedule/> */}
     
      <AnimationOnScroll animateIn="animate__zoomIn" delay="300" duration ="2.5">
      <Savings/>
      </AnimationOnScroll>    
      <AnimationOnScroll animateIn="animate__zoomIn" delay="300" duration ="2.5">
      <Countdown/>
      </AnimationOnScroll>
     
    </div>
  )
}

export default Welcome
